import styled from '@emotion/styled';
import { Component, createElement, createRef } from 'react';

export interface Props {
  src: string;
  playPosition?: number;
  loop?: boolean;
  muted?: boolean;
  autoPlay?: boolean;
  controls?: boolean;
  nodownload?: boolean;
  poster?: string;
  className?: string;
}

class ControlableVideoScreen extends Component<Props> {
  videoRef: any = createRef();

  componentDidUpdate() {
    if (this.videoRef.current && this.props.playPosition !== -1) {
      this.videoRef.current.currentTime = this.props.playPosition;
      this.videoRef.current.play();
    }
  }

  render() {
    return (
      <Root
        loop={this.props.loop}
        muted={this.props.muted}
        autoPlay={this.props.autoPlay}
        controls={this.props.controls}
        poster={this.props.poster}
        controlsList={this.props.nodownload ? 'nodownload' : undefined}
        innerRef={this.videoRef}
        className={this.props.className}
      >
        <source src={this.props.src} />
      </Root>
    );
  }
}

const Root = styled('video')({
  backgroundColor: '#000',
  objectFit: 'contain',
  width: '100%',
  height: '100%',
}) as any;

export default ControlableVideoScreen;
